"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _classnames = _interopRequireDefault(require("classnames"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdTable = _interopRequireDefault(require("cccisd-table"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _LackingPermissions = _interopRequireDefault(require("../../components/LackingPermissions"));
var _Overlay = _interopRequireDefault(require("../../components/Overlay"));
var _Sticky = _interopRequireDefault(require("../../components/Sticky"));
var _messageConditionTranslator = _interopRequireDefault(require("../../helpers/messageConditionTranslator.js"));
var _questPermissionsByArea = _interopRequireDefault(require("../../helpers/questPermissionsByArea.js"));
var _MessageViewer = _interopRequireDefault(require("./MessageViewer"));
var _SaveMessageModalContents = _interopRequireDefault(require("./SaveMessageModalContents.js"));
var _ScheduleMessageModalContents = _interopRequireDefault(require("./ScheduleMessageModalContents.js"));
var _style = _interopRequireDefault(require("./style.css"));
var _style2 = _interopRequireDefault(require("../../components/ModalContents/style.css"));
var _plus = _interopRequireDefault(require("cccisd-icons/plus2"));
var _atSign = _interopRequireDefault(require("cccisd-icons/at-sign"));
var _mobile = _interopRequireDefault(require("cccisd-icons/mobile"));
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil5"));
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _quill = _interopRequireDefault(require("cccisd-icons/quill2"));
var _alarmCheck = _interopRequireDefault(require("cccisd-icons/alarm-check"));
var _history = _interopRequireDefault(require("cccisd-icons/history"));
var _alarm = _interopRequireDefault(require("cccisd-icons/alarm"));
var _alarmCancel = _interopRequireDefault(require("cccisd-icons/alarm-cancel"));
var _copy = _interopRequireDefault(require("cccisd-icons/copy3"));
var _addressBook = _interopRequireDefault(require("cccisd-icons/address-book"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // *** STYLES ***
// *** ICONS ***
var Appdefs = window.cccisd.appDefs;
var Fortress = window.cccisd.fortress;

// *** CONSTANTS ***
var DRAFT = 'draft';
var TEMPLATE = 'template';
var SCHEDULED = 'scheduled';
var SENT = 'completed';
var VIEW = 'view';
var DATE_FORMAT_MOMENT = 'D MMM YYYY, h:mm A';
var Messaging = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function Messaging() {
    var _this;
    _classCallCheck(this, Messaging);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Messaging, [].concat(args));
    _defineProperty(_this, "state", {
      loading: false,
      tzAbbrev: _momentTimezone["default"].tz(_momentTimezone["default"].tz.guess()).format('z') // Why in state?
    });
    _defineProperty(_this, "deleteMessage", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(messageId) {
        var isSuccess;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.setState({
                loading: true
              });
              _context.n = 1;
              return _this.props.deleteMessage(_this.props.deployment.deploymentId, messageId);
            case 1:
              isSuccess = _context.v;
              _context.n = 2;
              return _this.props.loadMessageList();
            case 2:
              _this.setState({
                loading: false
              });
              if (isSuccess) {
                (0, _cccisdNotification["default"])('Message successfully deleted');
              } else {
                (0, _cccisdNotification["default"])({
                  type: 'danger',
                  message: 'Message failed to delete'
                });
              }
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    // Unschedule message
    _defineProperty(_this, "unscheduleMessage", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(messageId, label) {
        var isSuccess;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this.setState({
                loading: true
              });
              _context2.n = 1;
              return _this.props.unscheduleMessage(_this.props.deployment.deploymentId, messageId);
            case 1:
              isSuccess = _context2.v;
              _context2.n = 2;
              return _this.props.loadMessageList();
            case 2:
              _this.setState({
                loading: false
              });
              if (isSuccess) {
                (0, _cccisdNotification["default"])("Successfully deleted scheduling for '".concat(label, "'"));
              } else {
                (0, _cccisdNotification["default"])({
                  type: 'danger',
                  message: "Failed to delete scheduling for '".concat(label, "'")
                });
              }
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function (_x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }());
    // render [ + NEW ] button in saved area
    _defineProperty(_this, "_renderNewSavedButton", function (type) {
      var deploymentId = _this.props.deployment.deploymentId;
      var messageList = _this.props.messageList;
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].rightSide
      }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("a", {
          className: (0, _classnames["default"])(_style["default"].addButton, 'btn btn-primary btn-sm'),
          type: "button"
        }, /*#__PURE__*/_react["default"].createElement(_plus["default"], null), "\xA0\xA0Create message"),
        title: /*#__PURE__*/_react["default"].createElement("span", {
          className: _style2["default"].title
        }, "Create a new message"),
        formAutoFocus: true
      }, /*#__PURE__*/_react["default"].createElement(_SaveMessageModalContents["default"], {
        deploymentId: deploymentId,
        messageList: messageList,
        hideMessageReplacementNotes: _this.props.hideMessageReplacementNotes,
        requeryCallback: _this.props.loadMessageList
      })));
    });
    // render action buttons based on table type
    _defineProperty(_this, "_renderActionButtons", function (id, tableType, sendDateString) {
      tableType = tableType.toLowerCase();
      var deploymentId = _this.props.deployment.deploymentId;
      var deployment = _this.props.deployment;
      var messageList = _this.props.messageList;
      // get message object by messageId
      var messageObject = (0, _find2["default"])(messageList, function (msg) {
        return msg.messageId === id;
      });

      // RETURN - if no object
      if (messageObject === undefined) {
        return;
      }
      var viewButton = /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: (0, _classnames["default"])('btn btn-secondary btn-xs', _style["default"].fullWidthBtn)
        }, messageObject.messageMethod === 'email' ? /*#__PURE__*/_react["default"].createElement(_atSign["default"], null) : /*#__PURE__*/_react["default"].createElement(_mobile["default"], null), " Preview"),
        title: /*#__PURE__*/_react["default"].createElement("span", {
          className: _style2["default"].title
        }, "Previewing message"),
        size: messageObject.messageMethod === 'email' ? 'large' : 'small'
      }, /*#__PURE__*/_react["default"].createElement(_MessageViewer["default"], {
        messageObject: messageObject,
        sendDateStr: sendDateString,
        deployment: deployment
      }));
      var editButton = /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Edit"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-success btn-xs"
        }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], null)),
        title: /*#__PURE__*/_react["default"].createElement("span", {
          className: _style2["default"].title
        }, "Edit".concat(tableType !== 'template' ? " {tableType}" : '', " message '").concat(messageObject.settings.label, "'")),
        formAutoFocus: true
      }, /*#__PURE__*/_react["default"].createElement(_SaveMessageModalContents["default"], {
        deploymentId: deploymentId,
        messageList: messageList,
        hideMessageReplacementNotes: _this.props.hideMessageReplacementNotes,
        isEditing: true,
        messageObj: messageObject,
        requeryCallback: _this.props.loadMessageList
      })));
      var deleteButton = /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Delete"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-danger btn-xs",
        onClick: function onClick() {
          (0, _cccisdConfirm["default"])({
            message: 'Confirm delete?',
            description: "Are you sure you want to delete message '".concat(messageObject.settings.label, "' and any of its unsent scheduled messages?"),
            confirmLabel: 'Yes',
            abortLabel: 'Cancel'
          }).then(function () {
            _this.deleteMessage(id);
          });
        }
      }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null)));
      var editScheduleButton = messageObject.scheduleTime === null ? /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Edit Message"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-success btn-xs"
        }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], null)),
        title: /*#__PURE__*/_react["default"].createElement("span", {
          className: _style2["default"].title
        }, "Edit ", tableType, " message"),
        formAutoFocus: true
      }, /*#__PURE__*/_react["default"].createElement(_SaveMessageModalContents["default"], {
        deploymentId: deploymentId,
        messageList: messageList,
        hideMessageReplacementNotes: _this.props.hideMessageReplacementNotes,
        isEditing: true,
        messageObj: messageObject,
        requeryCallback: _this.props.loadMessageList
      }))) : /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Edit this Schedule"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-success btn-xs"
        }, /*#__PURE__*/_react["default"].createElement(_alarm["default"], null)),
        title: /*#__PURE__*/_react["default"].createElement("span", {
          className: _style2["default"].title
        }, "Change schedule for '".concat(messageObject.settings.label, "'"))
      }, /*#__PURE__*/_react["default"].createElement(_ScheduleMessageModalContents["default"], {
        messageObj: messageObject,
        requeryCallback: _this.props.loadMessageList,
        deploymentId: deploymentId,
        isEditing: true
      })));
      var deleteScheduleButton = messageObject.scheduleTime === null ? /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Delete Message"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-danger btn-xs",
        onClick: function onClick() {
          (0, _cccisdConfirm["default"])({
            message: 'Confirm message delete?',
            description: "Are you sure you want to delete scheduled message '".concat(messageObject.settings.label, "'?"),
            confirmLabel: 'Yes',
            abortLabel: 'Cancel'
          }).then(function () {
            _this.deleteMessage(id);
          });
        }
      }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null))) : /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Delete this Schedule"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-danger btn-xs",
        onClick: function onClick() {
          (0, _cccisdConfirm["default"])({
            message: 'Confirm schedule delete?',
            description: "Are you sure you want to delete this schedule for template '".concat(messageObject.settings.label, "'?"),
            confirmLabel: 'Yes',
            abortLabel: 'Cancel'
          }).then(function () {
            _this.unscheduleMessage(id, messageObject.settings.label);
          });
        }
      }, /*#__PURE__*/_react["default"].createElement(_alarmCancel["default"], null)));
      var duplicateButton = /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: tableType === SCHEDULED ? 'Duplicate Message' : 'Duplicate'
      }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-warning btn-xs"
        }, /*#__PURE__*/_react["default"].createElement(_copy["default"], null)),
        title: /*#__PURE__*/_react["default"].createElement("span", {
          className: _style2["default"].title
        }, "Duplicate ".concat(tableType, " message '").concat(messageObject.settings.label, "'")),
        formAutoFocus: true
      }, /*#__PURE__*/_react["default"].createElement(_SaveMessageModalContents["default"], {
        deploymentId: deploymentId,
        messageList: messageList,
        hideMessageReplacementNotes: _this.props.hideMessageReplacementNotes,
        messageObj: _objectSpread(_objectSpread({}, messageObject), {}, {
          settings: _objectSpread(_objectSpread({}, messageObject.settings), {}, {
            label: "".concat(messageObject.settings.label, " (duplicate)")
          })
        }),
        requeryCallback: _this.props.loadMessageList
      })));
      switch (tableType) {
        case VIEW:
          return /*#__PURE__*/_react["default"].createElement("span", {
            className: _style["default"].viewButton
          }, viewButton);
        case DRAFT: // fall-through
        case TEMPLATE:
          return /*#__PURE__*/_react["default"].createElement("span", {
            className: _style["default"].actionButtons
          }, editButton, duplicateButton, deleteButton);
        case SCHEDULED:
          return /*#__PURE__*/_react["default"].createElement("span", {
            className: _style["default"].actionButtons
          }, editScheduleButton, messageObject.scheduleTime === null && duplicateButton, deleteScheduleButton);
        case SENT:
          return;
        default:
          // safety - edit button
          return /*#__PURE__*/_react["default"].createElement("span", {
            className: _style["default"].actionButtons
          }, editButton);
      }
    });
    // correctly capitalize the Message Method display text
    _defineProperty(_this, "styleMessageTypeLabel", function (text) {
      switch (text.toUpperCase()) {
        case 'EMAIL':
          return 'Email';
        case 'SMS':
          return 'SMS/Text';
        default:
          return text;
      }
    });
    // format datetime as DD-MON-YYYY HH:MM (tz) using moment.js
    _defineProperty(_this, "dateTimeFormat", function (datetime) {
      if (datetime === null) {
        return '—';
      }
      return "".concat((0, _momentTimezone["default"])(_momentTimezone["default"].utc(datetime).format()).format(DATE_FORMAT_MOMENT), " (").concat(_this.state.tzAbbrev, ")");
    });
    _defineProperty(_this, "_renderConditionColumn", function (value) {
      return (0, _messageConditionTranslator["default"])(value);
    });
    // message type of cell
    _defineProperty(_this, "_renderMethodCell", function (message, time) {
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].messageTypeCell
      }, /*#__PURE__*/_react["default"].createElement("span", null, _this.styleMessageTypeLabel(message.messageMethod)), _this._renderActionButtons(message.messageId, VIEW, time === '' ? '' : _this.dateTimeFormat(time)));
    });
    _defineProperty(_this, "_renderToCell", function (message) {
      var showMsgCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var numRecs = message.recipients ? message.recipients.length : 0;
      var recBtn = /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn btn-xs btn-secondary"
      }, numRecs, " ", /*#__PURE__*/_react["default"].createElement(_addressBook["default"], null));
      var respBtn = /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Sent to ".concat(message.messageCount, " Respondent").concat(message.messageCount !== 1 ? 's' : ''),
        placement: "right"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn btn-xs btn-secondary"
      }, message.messageCount));
      var recipientTypes = ['on_respondent_complete_notify', 'on_respondent_complete_module_notify', 'on_respondent_complete_survey_notify', 'scheduled', 'scheduled_on_respondent_complete_notify', 'scheduled_on_respondent_complete_module_notify', 'scheduled_on_respondent_complete_survey_notify', 'scheduled_target_met', 'target_met', 'target_not_met'];
      return recipientTypes.includes(message.condition) ? /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].recList
      }, /*#__PURE__*/_react["default"].createElement("span", null, "Receiver List"), /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].hoverHelp
      }, numRecs === 0 ? recBtn : /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: message.recipients.join('<br />'),
        placement: "right"
      }, recBtn))) : /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].recList
      }, /*#__PURE__*/_react["default"].createElement("span", null, "Respondent(s)"), showMsgCount && /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].hoverHelp
      }, respBtn));
    });
    return _this;
  }
  _inherits(Messaging, _React$Component);
  return _createClass(Messaging, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var deployment = this.props.deployment;
      // RETURN - if no data
      if (!deployment) {
        return /*#__PURE__*/_react["default"].createElement("h1", null, "NO DATA");
      }
      if (!Fortress.hasAnyAccess([].concat(_toConsumableArray(_questPermissionsByArea["default"].deploy.permissions), ['quest.messaging']), deployment.assignment.groupId)) {
        return /*#__PURE__*/_react["default"].createElement(_LackingPermissions["default"], null);
      }
      var backLink = /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
        to: this.props.projectLinks.deploy
      }, this.props.backLinkText);
      if ((0, _get2["default"])(Appdefs, 'app.isQuestFreeTrial', false)) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "alert alert-info"
        }, /*#__PURE__*/_react["default"].createElement("p", null, "This feature is not available during trial period."), backLink);
      }

      // tables' columns
      var templateColumns = [{
        name: 'label',
        label: 'Label',
        sort: true,
        filter: true
      }, {
        name: 'method',
        label: 'Message Type',
        sort: true,
        filter: false
      }, {
        name: 'recipients',
        label: 'Recipients',
        sort: true,
        filter: false
      }, {
        name: 'condition',
        label: 'Condition',
        render: this._renderConditionColumn,
        sort: true,
        filter: true
      }, {
        name: 'lastModified',
        label: 'Last Modified',
        render: this.dateTimeFormat,
        sort: true,
        filter: false,
        filterSettings: {
          type: 'date'
        }
      }, {
        name: 'actions',
        label: 'Actions'
      }];
      var scheduledColumns = [{
        name: 'label',
        label: 'Label',
        sort: true,
        filter: true
      }, {
        name: 'method',
        label: 'Message Type',
        sort: true,
        filter: false
      }, {
        name: 'sendTo',
        label: 'Send To',
        sort: true,
        filter: false
      }, {
        name: 'condition',
        label: 'Condition',
        sort: true,
        filter: true,
        render: this._renderConditionColumn
      }, {
        name: 'sendOn',
        label: 'Send On',
        render: this.dateTimeFormat,
        sort: true,
        filter: false,
        filterSettings: {
          type: 'date'
        }
      }, {
        name: 'actions',
        label: 'Actions'
      }];
      var sentColumns = [{
        name: 'label',
        label: 'Label',
        sort: true,
        filter: true
      }, {
        name: 'method',
        label: 'Message Type',
        sort: true,
        filter: false
      }, {
        name: 'sentTo',
        label: 'Sent To',
        sort: true,
        filter: false
      }, {
        name: 'condition',
        label: 'Condition',
        sort: true,
        filter: true,
        render: this._renderConditionColumn
      }, {
        name: 'sentOn',
        label: 'Sent On',
        render: this.dateTimeFormat,
        sort: true,
        filter: false,
        filterSettings: {
          type: 'date'
        }
      }];

      // tables' data
      var templateData = [];
      var scheduledData = [];
      var sentData = [];
      var skippedConditions = ['scheduled_on_respondent_complete', 'scheduled_on_respondent_complete_notify', 'scheduled_on_respondent_complete_module', 'scheduled_on_respondent_complete_module_notify', 'scheduled_on_respondent_complete_survey', 'scheduled_on_respondent_complete_survey_notify', 'scheduled_on_respondent_rostered'];

      // saved message tables arrays
      (0, _map2["default"])(this.props.messageList, function (message) {
        var onCompleteTypes = ['on_respondent_complete', 'on_respondent_complete_notify', 'on_respondent_complete_module', 'on_respondent_complete_module_notify', 'on_respondent_complete_survey', 'on_respondent_complete_survey_notify', 'on_respondent_rostered'];
        var onCompleteNum = message.category === 'SCHEDULED' && onCompleteTypes.includes(message.condition) && message.messageCount > 0 ? "".concat(message.messageCount) : '';
        if (!skippedConditions.includes(message.condition) && (message.category === 'COMPLETED' || onCompleteNum)) {
          sentData.push({
            id: message.messageId,
            label: message.settings.label,
            method: _this2._renderMethodCell(message, message.completedAt),
            condition: message.condition,
            sentTo: _this2._renderToCell(message, true),
            sentOn: message.completedAt
          });
        }
        if (skippedConditions.includes(message.condition)) {
          // skip
        } else if (message.category === 'SCHEDULED') {
          scheduledData.push({
            id: message.messageId,
            label: message.settings.label,
            method: _this2._renderMethodCell(message, message.scheduleTime),
            condition: message.condition,
            sendTo: _this2._renderToCell(message),
            sendOn: message.scheduleTime,
            actions: _this2._renderActionButtons(message.messageId, message.category, _this2.dateTimeFormat(message.scheduleTime))
          });
        } else if (['DRAFT', 'TEMPLATE'].includes(message.category)) {
          templateData.push({
            id: message.messageId,
            label: message.settings.label,
            method: _this2._renderMethodCell(message, ''),
            recipients: _this2._renderToCell(message),
            condition: message.condition,
            lastModified: message.updatedAt,
            actions: _this2._renderActionButtons(message.messageId, message.category, '')
          });
        }
      });

      // RETURN - normal
      return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: this.state.loading
      }, /*#__PURE__*/_react["default"].createElement(_Overlay["default"], {
        title: "Messaging",
        backLink: backLink,
        breadcrumbs: this.props.breadcrumbs
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].messagingWrapper
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].savedArea,
        id: "messages_table"
      }, /*#__PURE__*/_react["default"].createElement(_Sticky["default"], null, /*#__PURE__*/_react["default"].createElement("header", null, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Message templates that can be used to create/edit scheduled messages",
        placement: "right"
      }, /*#__PURE__*/_react["default"].createElement("h1", null, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_quill["default"], null)), "Messages")), this._renderNewSavedButton(TEMPLATE))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].tableArea
      }, /*#__PURE__*/_react["default"].createElement(_cccisdTable["default"], {
        columns: templateColumns,
        data: templateData,
        hideShowingRowsSummary: true,
        perPage: 25,
        saveState: false,
        showBottomPaginator: true,
        showPerPageOptions: false
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        id: "scheduled_messages_table"
      }, /*#__PURE__*/_react["default"].createElement(_Sticky["default"], null, /*#__PURE__*/_react["default"].createElement("header", null, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Messages scheduled with a date and time or messages that have a specified send condition",
        placement: "right"
      }, /*#__PURE__*/_react["default"].createElement("h1", null, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].scheduledIcon
      }, /*#__PURE__*/_react["default"].createElement(_alarmCheck["default"], null)), "Scheduled")))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].tableArea
      }, /*#__PURE__*/_react["default"].createElement(_cccisdTable["default"], {
        columns: scheduledColumns,
        data: scheduledData,
        hideShowingRowsSummary: true,
        orderBy: "sendOn",
        perPage: 25,
        saveState: false,
        showBottomPaginator: true,
        showPerPageOptions: false
      }))), sentData.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].sentArea,
        id: "sent_messages_table"
      }, /*#__PURE__*/_react["default"].createElement(_Sticky["default"], null, /*#__PURE__*/_react["default"].createElement("header", null, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Messages that have been sent",
        placement: "right"
      }, /*#__PURE__*/_react["default"].createElement("h1", null, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].sentIcon
      }, /*#__PURE__*/_react["default"].createElement(_history["default"], null)), "Sent")))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].tableArea
      }, /*#__PURE__*/_react["default"].createElement(_cccisdTable["default"], {
        columns: sentColumns,
        data: sentData,
        hideShowingRowsSummary: true,
        isAscentOrder: false,
        orderBy: "sentOn",
        perPage: 25,
        saveState: false,
        showBottomPaginator: true,
        showPerPageOptions: false
      }))))));
    }
  }]);
}(_react["default"].Component);
_defineProperty(Messaging, "propTypes", {
  backLinkText: _propTypes["default"].string,
  breadcrumbs: _propTypes["default"].array,
  deleteMessage: _propTypes["default"].func,
  deployment: _propTypes["default"].object,
  messageList: _propTypes["default"].array,
  hideMessageReplacementNotes: _propTypes["default"].bool,
  projectLinks: _propTypes["default"].object,
  loadMessageList: _propTypes["default"].func,
  unscheduleMessage: _propTypes["default"].func
});
_defineProperty(Messaging, "defaultProps", {
  backLinkText: 'Go back to Deploy'
});